// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"e37bf36d","580":"fe871151"}[chunkId] + ".chunk.css";
};